// @flow

import { Session } from "./session";
import { IsNotAuthenticated as _IsNotAuthenticated } from "./session";
import { IsAuthenticated as _IsAuthenticated } from "./session";


export default Session;
export const IsNotAuthenticated = _IsNotAuthenticated;
export const IsAuthenticated = _IsAuthenticated;